/* Progressive enhancement for the COA request form (snippets/rp-coa-request-form.liquid).
   Posts the native contact form with fetch and confirms inline. Any problem (captcha challenge,
   network error, unexpected response) falls back to the normal full-page form submit. */
(function () {
  if (window.__rpCoaRequest) return;
  window.__rpCoaRequest = true;
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var wrap = form.closest('[data-rp-coa-request]');
    if (!wrap || !window.fetch) return;
    event.preventDefault();
    var button = form.querySelector('button[type="submit"]');
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
      .then(function (response) {
        var ok = response.ok && /contact_posted=true/.test(response.url) && !/\/challenge/.test(response.url);
        if (!ok) throw new Error('fallback');
        form.hidden = true;
        var done = wrap.querySelector('.rpx-coa__success--js');
        if (done) { done.hidden = false; done.focus(); }
      })
      .catch(function () {
        form.submit();
      });
  });
})();
